import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../../Core/Link';

export const Wrapper = styled.div`
  height: 480px;
`;

export const LinkWrapper = styled(Link)`
  margin-top: 1rem;
`;

export const TitleWrapper = styled.div`
  position: relative;
  padding: 0 30px;

  margin-top: auto;
  margin-bottom: auto;
  max-width: 465px;
  text-align: center;

  h2,
  h3,
  h4,
  h5,
  p {
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;
    text-align: center;
    color: ${themeGet('colors.white')};
    margin-bottom: 15px;
  }

  h2:last-child,
  h3:last-child,
  h4:last-child,
  h5:last-child,
  p:last-child {
    color: ${themeGet('colors.text-primary')};
    text-align: center;
    font-size: 24px;
    letter-spacing: -0.53px;
    line-height: 28px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    max-width: 765px;

    h2,
    h3,
    h4,
    h5,
    p {
      font-size: 26px;
      font-weight: bold;
      letter-spacing: -0.5px;
      line-height: 38px;
    }

    h2:last-child,
    h3:last-child,
    h4:last-child,
    h5:last-child,
    p:last-child {
      font-size: 38px;
      letter-spacing: -0.53px;
      line-height: 46px;
    }
  }
`;
